/** Canonical public home (logout redirect). Override with VITE_MPROLAB_HOME_URL for previews. */
export const MPROLAB_HOME_URL = (
  import.meta.env.VITE_MPROLAB_HOME_URL || 'https://mprolab.io'
).replace(/\/$/, '')

export const OPEN_WALLET_PANEL_QUERY = 'openConnect'
